import Vue from 'vue'
import scrollbar from 'vue2-perfect-scrollbar'
import 'vue2-perfect-scrollbar/dist/vue2-perfect-scrollbar.css'

// TODO: See if needed (PerfectScrollbar)
Vue.use(scrollbar)
